import type {
  ActionsForEntity,
  Entity,
  PermissionPair
} from '@wci/wv-db-schemas'
import { clsx, type ClassValue } from 'clsx'
import { format } from 'date-fns'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getInitials = (name: string | undefined | null) => {
  if (!name || typeof name !== 'string') return '?'
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
}

export const getColorFromString = (str: string | undefined | null): string => {
  if (!str || typeof str !== 'string') return 'hsl(0, 0%, 80%)' // fallback gray

  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  const hue = hash % 360
  return `hsl(${hue}, 70%, 50%)`
}

export function hasPermission<E extends Entity>(
  permissions: PermissionPair[],
  entity: E,
  action: ActionsForEntity<E>
): boolean {
  return permissions.some((p) => p.entity === entity && p.action === action)
}

export function hexToRgb(hex: string): [number, number, number] {
  const cleanHex = hex.replace('#', '')
  const bigint = parseInt(cleanHex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255
  return [r, g, b]
}

export function formatDate(val?: Date | string | null) {
  return val ? format(new Date(val), 'MM-dd-yyyy') : null
}
